import { render, staticRenderFns } from "./mybankPayRefundDetail.vue?vue&type=template&id=fc01b778&scoped=true"
import script from "./mybankPayRefundDetail.vue?vue&type=script&lang=js"
export * from "./mybankPayRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./mybankPayRefundDetail.vue?vue&type=style&index=0&id=fc01b778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc01b778",
  null
  
)

export default component.exports